import { basketOperations, basketTypes } from '../../store/basket';
import { call, put, takeLatest } from 'redux-saga/effects';

import { reloadBasket } from './helpers';

const { CHECK_BASKET } = basketTypes;

export const performCheckBasket = function* performCheckBasket({ payload }) {
  const { checkBasketComplete } = basketOperations;

  try {
    const basketResponse = yield call(reloadBasket, payload.bookingRef);
    if (basketResponse.errors) {
      yield put(checkBasketComplete());
    }
  } catch (error) {
    yield put(checkBasketComplete());
    // don't do anything
  }
};

export default takeLatest(CHECK_BASKET, performCheckBasket);
